import { Select as BaseSelect } from '@base-ui-components/react/select'
import * as React from 'react'
import { cn } from '../../utils/cn'
import { LineIcon } from '../line-icon'
import { useSelectContext } from './select-context'

export function SelectControl({ className, placeholder, ...props }: SelectControl.Props) {
  const { size, variant } = useSelectContext()
  return (
    <button
      className={cn(
        // Base
        'flex select-none items-center justify-between whitespace-nowrap rounded-md [&>span]:line-clamp-1',
        // Focus
        'focus-visible:ring-accent-600 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset',
        // Disabled
        'data-[disabled]:cursor-not-allowed data-[disabled]:opacity-50',
        // Size
        {
          sm: 'h-7 gap-1 py-1 pl-2.5 pr-2 text-xs',
          md: 'h-9 gap-2 py-2 pl-3.5 pr-3 text-sm',
        }[size],
        // Variant
        {
          ghost: 'hover:bg-gray-100 focus-visible:bg-gray-100',
          outline: 'bg-background shadow-xs ring ring-inset ring-gray-200',
        }[variant],
        className
      )}
      type="button"
      {...props}
    >
      <BaseSelect.Value placeholder={placeholder}>
        {(label, value) => <span className={cn(!value && 'text-gray-400')}>{label}</span>}
      </BaseSelect.Value>
      <BaseSelect.Icon className="flex">
        <LineIcon.ChevronDown
          className={cn(
            'text-gray-400',
            {
              sm: 'size-3',
              md: 'size-3.5',
            }[size]
          )}
        />
      </BaseSelect.Icon>
    </button>
  )
}

export namespace SelectControl {
  export interface Props extends Omit<React.ComponentProps<'button'>, 'children'> {
    placeholder: React.ReactNode
  }
}
